import { getUserData, getHomeRouteForLoggedInUser, isUserLoggedIn } from '@/auth/utils'

// Visibility follows existing admin entry; the server rechecks current roles, account state and session authority.
export default () => {
  const user = getUserData()
  return !!user && isUserLoggedIn() && !user.isBlocked && !user.isDeactivate
    && getHomeRouteForLoggedInUser(user.roles) === '/' && new Set(user.roles).size > 1
}
